import { LEVELS } from '../config/levels'

/**
 * Application-wide constants.
 * Centralized location for magic numbers and configuration values.
 */

// Storage
export const STORAGE_KEY = 'cito_meester_djayden_v2'

// XP & Leveling
export const XP_PER_LEVEL = 250

// XP Rewards
export const XP_REWARDS = {
  CORRECT_HARD: 30, // Plus levels
  CORRECT_MEDIUM: 25, // Standard levels group 7/8
  CORRECT_EASY: 20, // Standard levels group 6
  EFFORT: 5, // Wrong answer (participation)
} as const

// Session Configuration
export const SESSION_CONFIG = {
  QUESTIONS_PER_SESSION: 10,
  RECENT_QUESTIONS_LIMIT: 25, // Increased from 15 to prevent loops in small pools
  CITO_QUESTION_COUNT: 30,
  CITO_TIME_LIMIT_SECONDS: 45 * 60, // 45 minutes
} as const

// Mastery Thresholds (aligned with progressive mastery model)
export const MASTERY_THRESHOLDS = {
  MASTERED: 95, // Near-complete mastery of group content
  PRACTICED: 60, // Showing consistency
  LEARNING: 0, // Has started but not consistent
} as const

// Default values for new module progress
// Dynamically generated from all level IDs to support the full hierarchy
export const DEFAULT_MASTERY_BY_DIFFICULTY: Record<number, number> =
  LEVELS.reduce(
    (acc, level) => {
      acc[level.id] = 0
      return acc
    },
    {} as Record<number, number>,
  )

// Difficulty Labels (for display)
// Mapped from the centralized configuration
export const DIFFICULTY_LABELS: Record<number, string> = LEVELS.reduce(
  (acc, level) => {
    acc[level.id] = level.label
    return acc
  },
  {} as Record<number, string>,
)
